import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Channel } from 'models/Channels';
import AirbnbIcon from 'assets/images/icons/channels/airbnb.svg?react';
import useFetchPropertyChannelSettings from 'components/domain/channelSettings/useFetchPropertyChannelSettings';
import {
  CollapseLabel,
  CollapseStyled,
} from '../PropertySettingsReviewsTab.styles';
import { AirbnbGuestReviewsContainer } from './AirbnbGuestReviews.styles';

import OverallAirbnbRatings from './overallAirbnbRatings/OverallAirbnbRatings';
import AutomatedReviews from './AutomatedReviews';
import GuestReviews from './guestReviews/GuestReviews';

const AirbnbGuestReviewsSection = () => {
  const { uid: propertyUid } = useParams();
  const { t } = useTranslation();
  const { channelSettings, isFetching } =
    // @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    useFetchPropertyChannelSettings(propertyUid);

  const isAirbnbActive = !!channelSettings?.find(
    ({ enumId }) => enumId === Channel.airbnb,
  )?.isActive;

  if (!isAirbnbActive || isFetching) {
    return null;
  }

  const title = (
    <CollapseLabel>
      <AirbnbIcon />
      {t('pageProperty.reviews.airbnbGuest.airbnbGuestReviews')}
    </CollapseLabel>
  );

  return (
    <CollapseStyled
      variant="card"
      label={title}
      defaultExpanded
      data-testid="airbnb-guest-reviews-section"
    >
      <AirbnbGuestReviewsContainer>
        <OverallAirbnbRatings />
        <AutomatedReviews />
        <GuestReviews />
      </AirbnbGuestReviewsContainer>
    </CollapseStyled>
  );
};

export default AirbnbGuestReviewsSection;
